import { LobbyFiltersComponent } from './../lobby-filters/lobby-filters.component';
import { TournamentpopupComponent } from './../tournamentpopup/tournamentpopup.component';
import { GamepreviewpopupComponent } from './../gamepreviewpopup/gamepreviewpopup.component';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { LobbyService } from './../_services/lobby.service';
import { OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, forkJoin } from 'rxjs';
import { environment } from './../../environments/environment';
import { MatDialog } from '@angular/material';
import moment from 'moment-timezone';
import { Router, ActivatedRoute } from '@angular/router';
import { NewsfeedComponent } from '../newsfeed/newsfeed.component';
import { VerificationComponent } from '../verification/verification.component';
import { AddfundPopupComponent } from '../addfund-popup/addfund-popup.component';
var LobbyComponent = /** @class */ (function () {
    function LobbyComponent(store, _lobbyService, dialog, router, activeRoute) {
        var _this = this;
        this.store = store;
        this._lobbyService = _lobbyService;
        this.dialog = dialog;
        this.router = router;
        this.activeRoute = activeRoute;
        this.isMobile = false;
        this.leagues = [];
        this.emptyLobby = false;
        // game selector vars
        this.curGame = 'all';
        this.curGameAbbr = 'all';
        // sort vars
        this.tableSort = null;
        this.sortDirection = 'desc';
        // misc vars
        this.bucketURL = "" + environment.assetURL + '/assets/default/images/';
        this.siteURL = "" + environment.SITE_URL;
        this.prevScroll = 0;
        this.draftedToday = null;
        // filter vars
        this.showFilter = true;
        this.filters = null;
        // upcoming slate vars
        this.nextSlate = null;
        this.nextSlateGame = null;
        this.nextSlateClock = null;
        // timers
        this.lockClock = null;
        this.draftedClock = null;
        this.scrollBarWidth = 0;
        this.leagueLockCounter = {};
        this.leagueLockIntervalClock = {};
        this.leagueClockSet = {};
        this.isMac = false;
        this.darkMode = false;
        this.darkMode_ext = '';
        this.noDeposit = 0;
        this.firstLoad = 1;
        this.depositContent = '';
        this.depositTitle = '';
        this.showlobby = true;
        this.version = '';
        this.scrollBarWidth = this.getScrollbarWidth();
        if (navigator.appVersion.indexOf("Mac") != -1)
            this.isMac = true;
        if (router.url == '/user/refer-friend' || router.url == '/user/profile') {
            this.showlobby = false;
        }
        this.store.select('authData').subscribe(function (state) {
            if (localStorage.getItem('currentUser') == null) {
                // redirect to login page
                window.location.href = "" + environment.SITE_URL + '/logout';
            }
            if (state[0]) {
                _this.user = state[0];
                _this.noDeposit = (_this.user.successful_deposits != null && _this.user.successful_deposits == 0) ? 1 : 0;
                /**Load filter only first not when any userdata modified */
                if (_this.user)
                    _this.firstTimeDepositPopup();
                if (_this.firstLoad == 1) {
                    _this.firstLoad = 0;
                    _this.getFilters();
                }
            }
        });
        this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(function (state) {
            if (state.length > 0) {
                _this.isMobile = state[0];
            }
        });
        this.sub_balanceData = this.store.select('userBalance').subscribe(function (state) {
            if (state.length > 0) {
                _this.user.dollar_balance = state[0];
                if (_this.user.dollar_balance != 0) {
                    _this.noDeposit = 0;
                }
            }
        });
        this.sub_joinLeague = this._lobbyService.updateLeagueMember().subscribe(function (state) {
            if (state.status != null && state.status == 1) {
                var oldIndex_1 = 0;
                var newIndex_1 = 0;
                var currentJoined_1 = 0;
                _this.leagues.forEach(function (league, i) {
                    if (league.id == state.league_id) {
                        oldIndex_1 = i;
                        if (state.action == 'join') {
                            league.joined_entrants++;
                            if (state.joined_mem != null && parseInt(state.joined_mem) == _this.user.id)
                                league.league_member = state.joined_mem;
                        }
                        else {
                            league.joined_entrants--;
                            if (state.joined_mem != null && parseInt(state.joined_mem) == _this.user.id)
                                league.league_member = null;
                        }
                        currentJoined_1 = league.joined_entrants;
                        league.updateStatus = true;
                        setTimeout(function () {
                            league.updateStatus = false;
                        }, 1000);
                    }
                    else if (!newIndex_1 && league.joined_entrants == 0 && league.tournament_id == '0') {
                        newIndex_1 = i;
                    }
                });
                if (oldIndex_1 && newIndex_1 && (currentJoined_1 == 1 || currentJoined_1 == 0)) {
                    _this.moveLeague(oldIndex_1, newIndex_1);
                }
            }
        });
        this.sub_joinTournament = this._lobbyService.updateTournamentMember().subscribe(function (state) {
            if (state.status != null && state.status == 1) {
                var oldIndex_2 = 0;
                var newIndex_2 = 0;
                var currentJoined_2 = 0;
                _this.leagues.forEach(function (league, i) {
                    if (league.tournament_id == state.tournament_id && !league.updateStatus) {
                        league.updateStatus = true;
                        oldIndex_2 = i;
                        if (state.action == 'join') {
                            if (state.entities.is_fast != null) {
                                if (state.entities.is_fast == 1) {
                                    league.league_joined_entrants = state.entities.draft_entries;
                                }
                                league.joined_entrants = state.entities.total_entries;
                            }
                            else {
                                league.joined_entrants++;
                                league.league_joined_entrants++;
                            }
                            if (league.league_joined_entrants == league.draft_size) {
                                league.league_joined_entrants = 0;
                            }
                            if (state.joined_mem != null && parseInt(state.joined_mem) == _this.user.id)
                                league.league_member = state.joined_mem;
                        }
                        else {
                            if (state.entities.is_fast != null) {
                                if (state.entities.is_fast == 1) {
                                    league.league_joined_entrants = state.entities.draft_entries;
                                }
                                league.joined_entrants = state.entities.total_entries;
                            }
                            else {
                                league.joined_entrants--;
                                league.league_joined_entrants--;
                            }
                            if (state.joined_mem != null && parseInt(state.joined_mem) == _this.user.id)
                                league.league_member = null;
                        }
                        currentJoined_2 = league.joined_entrants;
                        setTimeout(function () {
                            league.updateStatus = false;
                        }, 1000);
                    }
                    else if (!newIndex_2 && league.joined_entrants == 0 && league.tournament_id != '0') {
                        newIndex_2 = i;
                    }
                });
                if (oldIndex_2 && newIndex_2 && (currentJoined_2 == 1 || currentJoined_2 == 0)) {
                    //this.moveLeague(oldIndex, newIndex);
                }
            }
        });
        this.sub_fillLeague = this._lobbyService.fillLeagueMember().subscribe(function (state) {
            if (state.status != null && state.status == 1) {
                _this.leagues.forEach(function (league) {
                    if (league.id == state.league_id) {
                        _this.leagues = _this.leagues.filter(function (lg) { return lg.id != league.id; });
                    }
                });
            }
        });
        this.sub_fillTournament = this._lobbyService.fillTournamentMember().subscribe(function (state) {
            if (state.status != null && state.status == 1) {
                _this.leagues.forEach(function (league) {
                    if (league.tournament_id == state.tour_id) {
                        _this.leagues = _this.leagues.filter(function (lg) { return lg.tournament_id != league.tournament_id; });
                    }
                });
            }
        });
        this.sub_currentGame = this._lobbyService.cgObservable.subscribe(function (state) {
            if (state.game != null && state.abbr != null && _this.curGame != state.game) {
                _this.curGame = state.game;
                _this.curGameAbbr = state.abbr;
                _this.leagues = [];
                _this.emptyLobby = false;
                _this.loadLobby();
            }
        });
        /*this._lobbyService.getDrafted().subscribe(state => {
          if (state.status == 'success') {
            this.draftedToday = state.leagues;
          }
        });*/
        // update once a minute
        /*this.draftedClock = setInterval(() => {
          this._lobbyService.getDrafted().subscribe(state => {
            if (state.status == 'success') {
              this.draftedToday = state.leagues;
            }
          });
        }, 60000);*/
        this.store.select('DarkModeReducer').subscribe(function (state) {
            if (state.length > 0) {
                _this.darkMode = state[0].isDarkMode;
                _this.darkMode_ext = _this.darkMode ? '-dark' : '';
            }
        });
    }
    LobbyComponent.prototype.firstTimeDepositPopup = function () {
        var _this = this;
        this.activeRoute.queryParams.subscribe(function (params) {
            _this.redirect = params['redirect'];
            var depsoit_status = params['depsoit'];
            var deposit_title = params['title'];
            var deposit_message = params['message'];
            if (_this.user) {
                var depositStaticContent = (_this.user.payment_verified == 'N' && _this.user.verify_before_deposits) ? 'verifyaccount' : 'specialoffer';
                _this._lobbyService.getStaticContent(depositStaticContent).subscribe(function (res) {
                    if (res.status == 'success') {
                        _this.depositContent = res.entities.description;
                        _this.depositTitle = res.entities.title;
                        if (_this.redirect != null && _this.redirect != '' && _this.redirect == "popup/cashier") {
                            _this.dialog.closeAll();
                            _this.dialog.open(AddfundPopupComponent, {
                                width: '850px',
                                data: { 'tab': 1 }
                            });
                        }
                        else if (_this.redirect != null && _this.redirect != '' && _this.redirect == "popup/verification") {
                            setTimeout(function () { return _this.openVerificationDialog(); }, 500);
                        }
                        else if (_this.redirect != null && _this.redirect != '') {
                            _this.confirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                                width: '500px',
                                data: { 'title': _this.depositTitle, 'body': _this.depositContent, 'type': 'first_deposit' }
                            });
                            _this.confirmDialogRef.afterClosed().subscribe(function (res) {
                                _this.router.navigate(['/lobby']);
                            });
                        }
                        else if (depsoit_status != null && depsoit_status != '') {
                            _this.confirmDialogRef = _this.dialog.open(ConfirmboxComponent, {
                                width: '500px',
                                data: { 'title': deposit_title, 'body': deposit_message, 'type': (depsoit_status == 'success') ? 'deposit_success' : 'deposit_pending' }
                            });
                            _this.confirmDialogRef.afterClosed().subscribe(function (res) {
                                _this.router.navigate(['/lobby']);
                            });
                        }
                    }
                });
            }
        });
    };
    LobbyComponent.prototype.openLeague = function (league_id, tournament_id, remain_people) {
        var _this = this;
        var dialogRef = null;
        if (tournament_id == 0) {
            dialogRef = this.dialog.open(GamepreviewpopupComponent, {
                width: '800px',
                data: { league_id: league_id },
                autoFocus: false
            });
        }
        else {
            dialogRef = this.dialog.open(TournamentpopupComponent, {
                width: '800px',
                data: {
                    league_id: league_id,
                    tournament_id: tournament_id,
                    remain_people: remain_people
                },
                autoFocus: false
            });
        }
        dialogRef.afterClosed().subscribe(function (result) {
            if (result != undefined && result.route != undefined)
                _this.router.navigate(result.route);
        });
        dialogRef.componentInstance.closePopupAndNavigate.subscribe(function (route) {
            dialogRef.close({ 'route': [route] });
        });
    };
    LobbyComponent.prototype.ngOnInit = function () {
        this.version = require('../../../package.json').version;
    };
    LobbyComponent.prototype.ngOnDestroy = function () {
        if (this.sub_isMobileScreen) {
            this.sub_isMobileScreen.unsubscribe();
        }
        if (this.sub_currentGame) {
            this.sub_currentGame.unsubscribe();
        }
        if (this.sub_fillLeague) {
            this.sub_fillLeague.unsubscribe();
        }
        if (this.sub_fillTournament) {
            this.sub_fillTournament.unsubscribe();
        }
        if (this.sub_joinLeague) {
            this.sub_joinLeague.unsubscribe();
        }
        if (this.sub_joinTournament) {
            this.sub_joinTournament.unsubscribe();
        }
        if (this.sub_balanceData) {
            this.sub_balanceData.unsubscribe();
        }
    };
    LobbyComponent.prototype.getFilters = function () {
        var _this = this;
        this._lobbyService.getFilters(this.user.id).subscribe(function (res) {
            if (res != null && res.buyin != null && res.entrant != null && res.use != null && res.contests != null && res.game_id != null) {
                _this.filters = res;
            }
            else {
                _this.filters = {
                    "apply_lobby_filter": "0",
                    "buy_in_orderby": "DESC",
                    "buyin": "0;10000",
                    "entrant": "0;10000",
                    "entrant_orderby": "DESC",
                    "game_id": "all",
                    "name": "",
                    "orderby": "",
                    "sortkey": "",
                    "use": "false",
                    "contests": "tiers,rankem,bestball,snake,gpp,multi,playoffs"
                };
            }
            _this.loadLobby();
        });
    };
    LobbyComponent.prototype.getJoinedEntrantsWidth = function (league, type) {
        if (type) {
            var a = [];
            if (league.tournament_id > 0) {
                for (var n = 0; n < league.draft_size; ++n) {
                    a.push(n);
                }
            }
            else {
                for (var n = 0; n < league.entrants; ++n) {
                    a.push(n);
                }
            }
            return a;
        }
        else {
            if (league.tournament_id > 0) {
                return 100 / parseInt(league.league_joined_entrants);
                // return (Math.floor(parseInt(league.league_joined_entrants) / parseInt(league.draft_size) * 100)) + '%';
            }
            else {
                return 100 / parseInt(league.joined_entrants);
                // return (Math.floor(parseInt(league.joined_entrants) / parseInt(league.entrants) * 100)) + '%';  
            }
        }
    };
    LobbyComponent.prototype.loadLobby = function () {
        var _this = this;
        this.leagues = [];
        this.leagueLockCounter = {};
        forkJoin({
            tournamentsRes: this._lobbyService.getTournaments(this.user.id, this.curGame),
            leaguesRes: this._lobbyService.getLeagues(this.user.id, this.curGame)
        }).subscribe(function (_a) {
            var tournamentsRes = _a.tournamentsRes, leaguesRes = _a.leaguesRes;
            if (tournamentsRes.status == 'success') {
                tournamentsRes.entities.forEach(function (tournament) {
                    if (tournament.tour_visibility == 'public' || _this.user.ac_type == 'test') {
                        tournament.tournament_id = tournament.id;
                        tournament.id = tournament.league_id;
                        tournament.league_member = (tournament.is_joined == 1) ? _this.user.id : null;
                        tournament.payout_amount = tournament.prize;
                        switch (tournament.drafttype_id) {
                            case 4:
                                tournament.draft_type = 'Rank\'EM';
                                break;
                            case 5:
                                tournament.draft_type = 'Classic Tiers';
                                break;
                            default:
                                tournament.draft_type = 'Snake Draft';
                                break;
                        }
                        tournament.earliest_game_schedule = tournament.pro_game_start_time;
                        if (!_this.leagueClockSet[tournament.draft_time]) {
                            _this.leagueLockClock(tournament.draft_time);
                        }
                        _this.leagues.push(tournament);
                    }
                });
                _this.emptyLobby = false;
            }
            _this.tableSort = null;
            _this.sortDirection = 'desc';
            if (leaguesRes.status == 'success') {
                _this.emptyLobby = false;
                leaguesRes.entities.forEach(function (league) {
                    if (league.publish_to_lobby == 'lobby_live' || _this.user.ac_type == 'test') {
                        if (!_this.leagueClockSet[league.draft_time]) {
                            _this.leagueLockClock(league.draft_time);
                        }
                        _this.leagues.push(league);
                    }
                });
            }
            //this.getNextSlate();
            _this.emptyLobby = false;
            _this.filterLobby();
        });
    };
    LobbyComponent.prototype.filterLobby = function () {
        var _this = this;
        if (this.filters != null && this.filters.use == 'true' && this.leagues.length) {
            // sports filter
            if (this.curGameAbbr == 'all' && this.filters.game_id != null && this.filters.game_id.split(',').indexOf('all') == -1) {
                this.leagues = this.leagues.filter(function (league) {
                    return _this.filters.game_id.indexOf(parseInt(league.game_id)) != -1;
                });
            }
            // entrants filter
            if (this.filters.entrant != null) {
                this.leagues = this.leagues.filter(function (league) {
                    return (parseInt(league.entrants) >= parseInt(_this.filters.entrant.split(';')[0]) && parseInt(league.entrants) <= parseInt(_this.filters.entrant.split(';')[1]));
                });
            }
            // buyins filter
            if (this.filters.buyin != null) {
                this.leagues = this.leagues.filter(function (league) {
                    return (parseFloat(league.buy_in_amount) >= parseFloat(_this.filters.buyin.split(';')[0]) && parseFloat(league.buy_in_amount) <= parseFloat(_this.filters.buyin.split(';')[1]));
                });
            }
            //search string
            if (this.filters.name != null && this.filters.name != '') {
                var regex_1 = new RegExp(this.filters.name, "gi");
                this.leagues = this.leagues.filter(function (league) {
                    return league.name.match(regex_1) != null;
                });
            }
            // subtractive contests filter
            if (this.filters.contests != null && this.filters.contests.split(',').length) {
                var contests = this.filters.contests.split(',');
                // tiers
                if (contests.indexOf('tiers') == -1) {
                    this.leagues = this.leagues.filter(function (league) { return league.drafttype_id != 5; });
                }
                // rankem
                if (contests.indexOf('rankem') == -1) {
                    this.leagues = this.leagues.filter(function (league) { return league.drafttype_id != 4; });
                }
                // bestball
                if (contests.indexOf('bestball') == -1) {
                    this.leagues = this.leagues.filter(function (league) { return league.duration_id != 8; });
                }
                // snake
                if (contests.indexOf('snake') == -1) {
                    this.leagues = this.leagues.filter(function (league) { return league.tournament_id > 0 || league.drafttype_id != 1 || (league.duration_id != 1 && league.duration_id != 2); });
                }
                // gpp
                if (contests.indexOf('gpp') == -1) {
                    this.leagues = this.leagues.filter(function (league) { return league.tournament_id == 0 || league.is_mode != 'gpp'; });
                }
                // multi
                if (contests.indexOf('multi') == -1) {
                    this.leagues = this.leagues.filter(function (league) { return league.tournament_id == 0 || league.is_mode != 'normal'; });
                }
                // playoffs
                if (contests.indexOf('playoffs') == -1) {
                    this.leagues = this.leagues.filter(function (league) { return league.duration_id != 5 && league.duration_id != 6; });
                }
            }
            // buyins sort
            if (this.filters.buy_in_orderby != null) {
                this.leagues.sort(function (a, b) {
                    return (_this.filters.buy_in_orderby == 'ASC') ? ((a.buy_in_amount > b.buy_in_amount) ? 1 : -1) : ((a.buy_in_amount > b.buy_in_amount) ? -1 : 1);
                });
            }
            // entrant sort
            if (this.filters.entrant_orderby != null) {
                this.leagues.sort(function (a, b) {
                    return (_this.filters.entrant_orderby == 'ASC') ? ((a.entrants > b.entrants) ? 1 : -1) : ((a.entrants > b.entrants) ? -1 : 1);
                });
            }
            // tournaments to the top
            this.leagues.sort(function (a, b) {
                return (a.tournament_id > b.tournament_id) ? -1 : 1;
            });
            // // contests filter (snake/rankem)
            // if (this.filters.contests != null && this.filters.contests.indexOf('all') == -1){
            //   this.leagues = this.leagues.filter(league=>{
            //     return ((this.filters.contests.indexOf('snake') > -1 && league.drafttype_id == 1) || (this.filters.contests.indexOf('rankem') > -1 && league.drafttype_id == 4));
            //   });
            // }
        }
        if (this.leagues.length) {
            this.emptyLobby = false;
        }
        else {
            this.emptyLobby = true;
        }
    };
    LobbyComponent.prototype.trackLeague = function (index, item) {
        return item.id;
    };
    LobbyComponent.prototype.getSchedule = function (duration, egs, lgs, week, game_id, tournament_id) {
        moment.tz.setDefault("America/New_York");
        switch (duration) {
            case '2':
                return (tournament_id > 0) ? moment.unix(egs).format('ddd, MMM DD') : 'Week ' + week;
                break;
            case '5':
                return 'Full Playoffs';
                break;
            case '6':
                return 'Playoff Round';
                break;
            case '8':
                //return (game_id == '2') ? 'Week 1 - 16' : (game_id == '4') ? 'Week 1 - 19' : 'Regular Season';
                return moment.unix(egs).format('ddd, MMM DD');
                break;
            case '7':
                return moment.unix(egs).format('ddd ') + '-' + moment.unix(lgs).format('ddd ') + '(' + moment.unix(lgs).format('MMM') + ' ' + moment.unix(egs).format('DD') + '-' + moment.unix(lgs).format('DD') + ')';
                break;
            default:
                return moment.unix(egs).format('ddd, MMM DD');
                break;
        }
    };
    LobbyComponent.prototype.sortTable = function (sort, type) {
        if (this.tableSort == sort)
            this.sortDirection = (this.sortDirection == 'asc') ? 'desc' : 'asc';
        this.tableSort = sort;
        var sortMod = (this.sortDirection == 'asc') ? -1 : 1;
        this.leagues.sort(function (a, b) {
            // tournaments over regular leagues
            if (a.tournament_id > 0 && b.tournament_id == 0) {
                return -1;
            }
            else if (a.tournament_id == 0 && b.tournament_id > 0) {
                return 1;
            }
            if (type == 0) {
                return (a[sort] < b[sort]) ? sortMod : sortMod * -1;
            }
            else if (type == 1) {
                return (parseInt(a[sort]) < parseInt(b[sort])) ? sortMod : sortMod * -1;
            }
            else if (type == 2) {
                return (parseFloat(a[sort]) < parseFloat(b[sort])) ? sortMod : sortMod * -1;
            }
        });
    };
    LobbyComponent.prototype.lobbyScroll = function (event) {
        /*const scrollDirection = (this.prevScroll > event.target.scrollTop) ? 'up' : 'down';
        if (scrollDirection == 'up') {
          this.showFilter = true;
        } else {
          this.showFilter = false;
        }*/
        this.prevScroll = event.target.scrollTop;
    };
    LobbyComponent.prototype.getNextSlate = function () {
        var earliestSlate = 9999999999;
        var earliestGame = null;
        this.leagues.forEach(function (league) {
            if (league.earliest_game_schedule < earliestSlate) {
                earliestSlate = league.earliest_game_schedule;
                earliestGame = league.league_type.toLowerCase();
            }
        });
        this.nextSlate = earliestSlate;
        this.nextSlateGame = earliestGame;
        if (this.nextSlateGame != null) {
            this.upcomingLock();
        }
        else {
            this.nextSlateClock = null;
            clearInterval(this.lockClock);
        }
    };
    LobbyComponent.prototype.lpad = function (int) {
        return String(int).length == 1 ? '0' + String(int) : String(int);
    };
    LobbyComponent.prototype.upcomingLock = function () {
        var _this = this;
        clearInterval(this.lockClock);
        this.lockClock = setInterval(function () {
            var now = Math.floor(Date.now() / 1000);
            var diff = _this.nextSlate - now; //in seconds
            var hours = Math.floor((diff / 60) / 60);
            var mins = Math.floor((diff / 60) - (hours * 60));
            var seconds = Math.floor(diff - hours * 3600 - mins * 60);
            if (hours < 0 || mins < 0 || seconds < 0) {
                _this.nextSlateClock = 'Live!';
            }
            else {
                _this.nextSlateClock = 'Until lock: ' + _this.lpad(hours) + ':' + _this.lpad(mins) + ':' + _this.lpad(seconds);
            }
        }, 1000);
    };
    LobbyComponent.prototype.leagueLockClock = function (draft_time) {
        var _this = this;
        this.leagueClockSet[draft_time] = true;
        if (this.leagueLockIntervalClock[draft_time]) {
            clearInterval(this.leagueLockIntervalClock[draft_time]);
        }
        this.leagueLockIntervalClock[draft_time] = setInterval(function () {
            var now = Math.floor(Date.now() / 1000);
            var diff = draft_time - now; //in seconds
            var hours = Math.floor((diff / 60) / 60);
            var mins = Math.floor((diff / 60) - (hours * 60));
            var seconds = Math.floor(diff - hours * 3600 - mins * 60);
            if (hours < 0 || mins < 0 || seconds < 0) {
                clearInterval(_this.leagueLockIntervalClock[draft_time]);
                _this.leagues = _this.leagues.filter(function (l) { return l.draft_time != draft_time; });
                delete _this.leagueLockCounter[draft_time];
            }
            else if (hours > 24) {
                _this.leagueLockCounter[draft_time] = false;
            }
            else {
                _this.leagueLockCounter[draft_time] = _this.lpad(hours) + ':' + _this.lpad(mins) + ':' + _this.lpad(seconds);
            }
        }, 100);
    };
    LobbyComponent.prototype.openFilters = function () {
        var _this = this;
        var dialogRef = null;
        if (this.isMobile) {
            dialogRef = this.dialog.open(LobbyFiltersComponent, {
                width: '75%',
                data: {
                    user_id: this.user.id,
                    filters: this.filters
                },
                autoFocus: false
            });
        }
        else {
            dialogRef = this.dialog.open(LobbyFiltersComponent, {
                width: '650px',
                data: {
                    user_id: this.user.id,
                    filters: this.filters
                },
                autoFocus: false
            });
        }
        dialogRef.afterClosed().subscribe(function (res) {
            if (res != null && res.game_id != null) {
                _this.filters = res;
                _this.loadLobby();
            }
        });
    };
    LobbyComponent.prototype.moveLeague = function (oldIndex, newIndex) {
        if (newIndex >= this.leagues.length) {
            newIndex = this.leagues.length - 1;
        }
        this.leagues.splice(newIndex, 0, this.leagues.splice(oldIndex, 1)[0]);
        return;
    };
    LobbyComponent.prototype.lobbyScrolling = function (elm) {
        return elm.scrollHeight > elm.clientHeight;
    };
    LobbyComponent.prototype.getScrollbarWidth = function () {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);
        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);
        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);
        return scrollbarWidth;
    };
    LobbyComponent.prototype.disableFilters = function () {
        this.filters.use = 'false';
        this.filters.apply_lobby_filter = '0';
        this.loadLobby();
        this._lobbyService.storeFilters(this.filters, this.user.id).subscribe(function (state) {
            // nothing
        });
    };
    LobbyComponent.prototype.lRowVisible = function (index, container) {
        var rowH = 49;
        var topIndex = Math.floor(container.scrollTop / rowH);
        var bottomIndex = Math.ceil((container.scrollTop + container.clientHeight) / rowH);
        return index >= topIndex && index < bottomIndex;
    };
    LobbyComponent.prototype.makePayment = function () {
        if (this.user.payment_verified === 'N' && this.user.verify_before_deposits) {
            this.openVerificationDialog();
        }
        else {
            window.location.href = environment.SITE_URL + "/drafts/register/welcome";
        }
    };
    LobbyComponent.prototype.openVerificationDialog = function () {
        this.dialog.closeAll();
        this.dialog.open(VerificationComponent, {
            width: '500px',
            data: {
                user: this.user,
                lobby: true
            }
        });
    };
    LobbyComponent.prototype.openAddfundPopupComponent = function () {
        this.dialog.closeAll();
        this.dialog.open(AddfundPopupComponent, {
            width: '850px',
            data: { 'tab': 1 }
        });
    };
    return LobbyComponent;
}());
export { LobbyComponent };
